/**
 * @fileoverview Module for `src/lib/routes/LoggedInRoute.js`.
 */

import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import Tracker from '../Tracker';
import { useAuth } from '../../contexts/AuthContext';

import UserChecker from './UserChecker';

/**
 * Route wrapper that only renders content for authenticated users.
 *
 * @param {Object} params
 * @param {Function} params.component - Protected component.
 * @param {boolean} [params.redirectToLogin=false] - If true, redirects
 *   unauthenticated users to the login flow instead of `/`.
 * @returns {JSX.Element} Wrapped protected route.
 */
function LoggedInRoute({ component, redirectToLogin, ...routeProps }) {
  const auth = useAuth();

  const tracker = useMemo(() => new Tracker({ auth }), [auth]);

  tracker.trackSegment();

  if (window?.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
    });
  }

  return (
    <Route { ...routeProps }>
      <UserChecker component={ component } redirectToLogin={ redirectToLogin } />
    </Route>
  );
}

LoggedInRoute.propTypes = {
  component: PropTypes.func.isRequired,
  redirectToLogin: PropTypes.bool,
};

LoggedInRoute.defaultProps = {
  redirectToLogin: false,
};

export default LoggedInRoute;
